
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/report/flood",
      function () {
        return require("private-next-pages/report/flood.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/report/flood"])
      });
    }
  